import { editorContextStore } from "@/contexts/editor-context";
import { isPricingConfigVersion, PricingConfigVersion } from "@/core/common/types/pricing-config";
import React from "react";

export function usePricingConfigUpdateEffect() {
  const backend = editorContextStore((state) => state.backend);
  const user = editorContextStore((state) => state.user);

  React.useEffect(() => {
    if (!backend || !user) {
      return;
    }

    const versionEnv = import.meta.env.VITE_PRICING_CONFIG_VERSION ?? "";
    const version = isPricingConfigVersion(versionEnv)
      ? versionEnv
      : PricingConfigVersion.Oct9th2024;

    return backend.onPricingConfigUpdate({
      version,
      callback: (pricingConfig) => {
        if (pricingConfig) {
          editorContextStore.getState().setPricingConfig(pricingConfig);
        }
      },
    });
  }, [backend, user]);
}
